module.exports = __webpack_public_path__ + "img/about-2.4d12f7d.jpg";